<template>
  <v-container fluid>
    <h1>About Us</h1>
    <v-row>
      <v-col cols="12" xl="8" lg="8" md="8" sm="12">
        <v-row>
          <v-col cols="12">
        <p>
          Don’t trust your most valuable asset to just any roofing companies
          with a truck. 
          <linkto text="AquaDuct Roof and Gutters" to="/"></linkto> has proudly served the
          Colorado Front Range for over 40 years. We are family-owned and
          operated, and adhere to the highest standards for quality
          installations and customer service.
        </p>
        <p>
          Long-time customers may remember us as A-1 Home Contractors, with an
          office for many years on West Alameda Avenue in 
          <linkto text="Denver" to="location/denver"></linkto>. We’re the same
          company, still owned by Scott Lawrence, son of Bill Lawrence, who
          started the company in 1972. In 1992, we expanded into Southern
          Colorado, providing the same excellent products and services to
          families in <linkto text="Colorado Springs" to="location/coloradosprings"></linkto> 
          and <linkto text="Pueblo" to="location/pueblo"></linkto>.
        </p>
        <p>
          In 2005, the company changed its name to AquaDuct Roof and Gutters
          after Scott’s son took the reins of the marketing department. While
          the logo and name changed at that time, the Lawrence family’s
          uncompromising dedication to quality and customer service has always
          remained the same.
        </p>
        </v-col>
        </v-row>
    <v-row :class="theme + '-alt-background-1'">
      <v-col cols="12">
        <h2>
          Certifications That Set Us Apart from Other Roofing Contractors in
          <linkto text="Denver" to="location/denver"></linkto>
        </h2>
        <p>
          You should expect <linkto location="Colorado Springs" to="location/coloradosprings"></linkto> 
          roofing contractors to install the
          best materials available, using the best techniques. That’s why
          <linkto text="AquaDuct Roof and Gutters" to="/"></linkto> 
          proudly carries quality products from the
          following manufacturers, and is certified in the latest installation
          techniques for each.
        </p>
        <ul>
          <li>Owens Corning</li>
          <li>CertainTeed</li>
          <li>GAF</li>
          <li>TAMKO</li>
          <li>Mastic</li>
          <li>Alcoa</li>
          <li>Simonton</li>
          <li>System Home Improvements</li>
        </ul>
        <p>
          Manufacturers will only honor a warranty if the installation was
          completed by one of their factory-certified roofing contractors, so
          our ongoing certifications provide an important benefit for our
          customers. Even if a non-certified Denver roofing contractor installs
          these products to manufacturer specifications, he will not be able to
          offer you the warranty protection you’ll get from AquaDuct!
        </p>
        <p>
          AquaDuct maintains an outstanding A+ rating with the Better Business
          Bureau. In addition, our care and dedication to excellence has earned
          us the Bureau’s coveted Gold Star Award five years in a row! This
          recognition is given to Denver roofing contractors that display
          excellence in customer service and have had no consumer complaints.
          One year with no complaints is a difficult feat in any industry, so
          we’re especially proud of this achievement.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2>
          Get an Estimate from the Best Roofing Contractors in Colorado Springs
        </h2>
        <p>
          If you’re tired of leaky Colorado Springs roofing, gutter cleaning,
          ice dam build-up or having water drips damage your siding, it’s time
          to give AquaDuct Roof and Gutters a call at 
           <phonenumber phone="(719) 390-7663"></phonenumber>. For more
          information on our service areas, including 
          <linkto text="Denver" to="location/denver"></linkto>, 
          <linkto text="Colorado Springs" to="location/coloradosprings"></linkto>,
          <linkto text="Peyton" to="location/peyton"></linkto>, 
          <linkto text="Castle Rock" to="location/castlerock"></linkto> and 
          <linkto text="Pueblo" to="location/pueblo"></linkto>, kindly visit our 
          <linkto text="Contact Us" to="/contact"></linkto> page.
        </p>
      </v-col>
    </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="4" sm="12">
        <estimate></estimate>
        <guild></guild>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import estimate from "../../components/controls/estimate-ctrl";
import router from "@/_router/index";
import guild from "@/components/controls/guild-quality";
import phonenumber from "@/components/controls/phone-number";
import linkto from "@/components/controls/link-to";
export default {
  name: "About-Home",

  components: {
    estimate,
    guild,
    linkto,
    phonenumber
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  data: () => ({
    image: require("@/assets/roof-7.jpeg"),
  }),

  methods: {
    onAbout() {
      router.push("/about/home");
    },
  },
};
</script>

<style lang="scss" scoped>
.after-image {
  margin-top: 20px;
  margin-bottom: 20px;
}

.subtitle-span {
  background: rgba(0, 0, 0, 0.5);
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  float: left;
}
</style>
